import { render, staticRenderFns } from "./FormComentarioLiquidacion.vue?vue&type=template&id=11550c93&"
import script from "./FormComentarioLiquidacion.vue?vue&type=script&lang=js&"
export * from "./FormComentarioLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports